import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Search } from "../search/SearchTypes";
import { getViewportName } from "../../ts/sframe/ViewportRoot";
import { gsap } from "gsap";
import Tools from "../../ts/Tools";


export default class ImgHeader extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
    this.writeBackgroundCss();
  }

  change(data: Search.HeaderData)
  {


    this.$root.find(".title").text(data.title);
    this.$root.find(".sub-title").text(data.sub_title);

    let img = new Image,
      $picture = this.$root.find("picture"),
      src = getViewportName() === "mobile" ? data.picture.mobile : data.picture.pc;

    $picture.css("transition", "none");


    this.$root.find(`img`).attr("src", data.picture.pc);
    this.$root.find(`source`).attr("srcset", data.picture.mobile);

    gsap.killTweensOf($picture[0])
    gsap.set($picture[0], { opacity: 0 });

    img.onload = () =>
    {
      gsap.to($picture[0], {
        opacity: 1, delay: .1, duration: .5, ease: "power1.in", onComplete: () =>
        {
          this.writeBackgroundCss();
        }
      });
    };


    img.src = src;
  }

  writeBackgroundCss()
  {
    Tools.addCustomStyle_2("img-header-styles", `[component="img-header"]`, `background-image: url(${this.$root.find("img").attr("src")})`, false, true);
    Tools.addCustomStyle_2("img-header-styles", `[component="img-header"]`, `background-image: url(${this.$root.find("source").attr("srcset")})`, true, false);

  }
}